import React, { useState } from "react";
import { useMenuAuthInfo } from "../../services/GlobalUtil";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import api from "../../services/api";
import BreadCrumbDiv from "../../components/common/BreadCrumbDiv";
import InputWrapDiv from "../../components/common/InputWrapDiv";
import TopBoxDiv from "../../components/common/TopBoxDiv";
import ContentInput from "../../components/common/ContentInput";
import ButtonWrapDiv from "../../components/common/ButtonWrapDiv";
import FunctionButton from "../../components/common/FunctionButton";
import MessageDialog from "../../components/common/MessageDialog";

const Vci2VersionAddPage = () => {
  const menuAuthInfo = useMenuAuthInfo();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogMessage, setDialogMessage] = useState("");

  const [ver, setVer] = useState("");

  const handleVersionChange = (e) => {
    setVer(e.target.value.trim());
  };

  const handleSubmit = () => {
    api
      .post("/manage/vci2version/insert", {
        ver: ver,
        creId: JSON.parse(sessionStorage.getItem("userInfo"))?.userId || "",
      })
      .then((response) => {
        if (response.data === 0) {
          setDialogMessage("L0103");
          setDialogOpen(true);
        } else if (response.data === 1301) {
          setDialogMessage("L0764");
          setDialogOpen(true);
        } else {
          setDialogMessage("L0459");
          setDialogOpen(true);
        }
      })
      .catch((error) => {
        console.error("Error Vci2 Version Insert:", error);
      });
  };

  const handleCancel = () => {
    navigate(-1);
  };

  return (
    <div>
      <BreadCrumbDiv items={[t("MENU:L0056"), t("MENU:L0958")]} />

      <InputWrapDiv>
        <TopBoxDiv value={t("MENU:L0958") + " " + t("L0016")} />

        <table>
          <tr>
            <th>{t("L0143")}</th>
            <td>
              <ContentInput
                value={ver}
                maxLength={500}
                onChange={handleVersionChange}
                disabled={!menuAuthInfo.edit}
              />
            </td>
          </tr>
        </table>
      </InputWrapDiv>

      <ButtonWrapDiv className="btn_bottom">
        {menuAuthInfo.edit && (
          <FunctionButton
            className="big"
            value={t("L0659")}
            onClick={handleSubmit}
          />
        )}
        <FunctionButton
          className="big bg_gray"
          value={t("L0005")}
          onClick={handleCancel}
        />
      </ButtonWrapDiv>

      {dialogOpen && (
        <MessageDialog title={t("L0339")} message={t(dialogMessage)}>
          {dialogMessage === "L0103" ? (
            <FunctionButton
              value={t("L0004")}
              onClick={() => {
                setDialogOpen(false);
                navigate("/manage/vci2version");
              }}
            />
          ) : (
            <FunctionButton
              value={t("L0004")}
              onClick={() => {
                setDialogOpen(false);
              }}
            />
          )}
        </MessageDialog>
      )}
    </div>
  );
};

export default Vci2VersionAddPage;
